/**
 * 构建期注入的运行配置。
 *
 * Vite 把 `VITE_*` 在构建时内联进产物，**不是运行时读取**——所以改这个值必须重新构建
 * 并重新发布，改 Cloudflare 的环境变量是不生效的（deploy-web.yml 里它作为构建步骤的
 * env 传入，就是这个原因）。
 */

/**
 * API 的源。
 *
 * 留空 = 相对路径，也就是同源：开发态由 Vite 代理到 :3079，单机部署由 Hono 自己托管
 * 前端产物。分域部署（前端在 Cloudflare Pages）必须填 API 的完整源，
 * 例如 `https://admin-api-dev.3.meme`。
 *
 * 末尾斜杠会被去掉——`https://x/` 和 `https://x` 拼出来的 URL 不一样，
 * 而多一道斜杠会让 Origin 比对在服务端那侧对不上。
 */
export const API_BASE: string = (import.meta.env.VITE_API_BASE ?? '').replace(/\/+$/, '')

/**
 * WalletConnect (Reown) 的 projectId。
 *
 * **它不是密钥，不用当 secret 管。** 任何 dApp 的 projectId 都原样躺在自己的 JS 产物里，
 * 藏不住也不需要藏——真正的访问控制是 Reown 控制台上的**域名白名单**。
 * 所以这里直接写字面量，env 只作为覆盖入口（要给 dev/prod 分开配置时才用得上）。
 *
 * ⚠️ 换域名或加新环境，必须去 Reown 控制台把域名加进白名单。
 * 漏加的表现是**扫码弹窗能打开、但钱包侧报来源不受信任而拒绝**，
 * 前端这边只会收到一个语焉不详的连接失败。当前需要覆盖的源：
 * `https://admin.ignix.bot`、`https://admin-dev.3.meme`、`http://localhost:3078`。
 *
 * 留空 = 关掉 WalletConnect 入口（选择器里置灰并说明原因），其余钱包照常工作。
 */
export const WALLETCONNECT_PROJECT_ID: string = (
  import.meta.env.VITE_WALLETCONNECT_PROJECT_ID ?? 'b4c3fc46b3874092105913837661daf2'
).trim()
